'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getObservationsType = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _constants = require('../constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getObservationsType = exports.getObservationsType = function getObservationsType(data) {
  if (R.isNil(data)) {
    return undefined;
  }
  var firstObs = R.pipe(R.pathOr({}, ['dataSets', 0, 'observations']), R.values, R.find(function (obs) {
    return R.not(R.either(R.isNil, R.isEmpty)(R.head(obs)));
  }))(data);
  if (R.isNil(firstObs)) {
    return undefined;
  }
  var firstObsValue = R.head(firstObs);
  if (R.is(Number, firstObsValue)) {
    return _constants.OBS_TYPE_NUMBER;
  }
  return R.ifElse(R.equals(NaN), R.always(_constants.OBS_TYPE_STRING), R.always(_constants.OBS_TYPE_NUMERICAL_STRING))(Number(firstObsValue));
};